export function smtpFormFields() {
  const names = [
    "smtpName",
    "smtpHost",
    "smtpPort",
    "smtpEmail",
    "smtpSender",
    "smtpSenderEmail",
    "smtpPassword"
  ];
  return names;
}